import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'portals-password-icon',
  templateUrl: './password-icon.component.html',
  styleUrls: ['./password-icon.component.scss']
})
export class PasswordIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
